import { render } from "./LoopingVideo.vue?vue&type=template&id=28a1e634&ts=true"
import script from "./LoopingVideo.vue?vue&type=script&lang=ts"
export * from "./LoopingVideo.vue?vue&type=script&lang=ts"

import "./LoopingVideo.vue?vue&type=style&index=0&id=28a1e634&lang=scss"

import exportComponent from "/home/runner/work/digital-creative-website/digital-creative-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__